import { Tab, Tabs, TabsHeader } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RDSChatroomList from "../components/RDSChatroomList";
import { getTokenFromLocalStorage } from "../lib/local-storage";
import { useChatFilters } from "../store/filters";

export default function ChatroomsListPage() {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  // const [chatroomFilter, setChatroomFilter] = useState('all');
  const {chatroomFilter, setChatroomFilter} = useChatFilters();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getTokenFromLocalStorage();
    setToken(token);
    setLoading(false);
  }, []);

  const tabs = [
		{
			label: 'All',
			value: 'all',
		},
		{
			label: 'Active',
			value: 'active',
		},
    {
			label: 'Inactive',
			value: 'inactive',
		},
	];

  return loading || !token ? null : (
    <div className="max-w-4xl mx-auto mt-7 px-2 pb-2">
      <div className="flex justify-between items-center p-3 h-20">
        <div className="flex justify-center"><h5 className="text-xl max-h-fit font-semibold">Support Chats</h5></div>
        <Tabs value={chatroomFilter}>
						<TabsHeader>
							{tabs.map(({ label, value }) => (
								<Tab
									key={value}
									value={value}
									onClick={() => setChatroomFilter(value)}
								>
									&nbsp;&nbsp;{label}&nbsp;&nbsp;
								</Tab>
							))}
						</TabsHeader>
					</Tabs>
      </div>
      <RDSChatroomList
        token={token}
        params={{ chatroomType: "superadmin_chat" }}
        hideParticipants={false}
        onClickChatroom={(room) => {
          navigate(`/chatrooms/${room.chatroomKey}`);
        }}
        pollingMode="get-mine"
        selectFirstChatroomOnLoad={false}
        chatroomFilter={
          chatroomFilter === 'all' ? () => true : chatroomFilter === 'active' ? (chatroom) => !!chatroom.active : (chatroom) => !chatroom.active
        }
      />
    </div>
  );
}
